import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isCpanelAuthenticated } from '../../../helpers/cpanelAuth';

export const CpanelAuthGuard = () => {
  const location = useLocation();

  if (!isCpanelAuthenticated()) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export const CpanelGuestGuard = () => {
  if (isCpanelAuthenticated()) {
    return <Navigate to="/cpanel/dashboard" replace />;
  }

  return <Outlet />;
};
